import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/macro-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/macro-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/macro-calculator",
      title: m.macro_meta_title(),
      description: m.macro_meta_description(),
      toolName: m.macro_tool_name(),
      faqs: [
        { q: m.macro_faq_q1(), a: m.macro_faq_a1() },
        { q: m.macro_faq_q2(), a: m.macro_faq_a2() },
        { q: m.macro_faq_q3(), a: m.macro_faq_a3() },
        { q: m.macro_faq_q4(), a: m.macro_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
